import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, PageMetaResolver, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { kbDateFormatPipe } from 'src/app/pipes/kbdate.pipe';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { AddressSelectPopupComponent } from './address-select-popup/address-select-popup.component';
import { KbCheckoutparentComponent } from './kb-checkoutparent/kb-checkoutparent.component';
import { KbcheckoutstepperComponent } from './kbcheckoutstepper/kbcheckoutstepper.component';
import { OrderSummaryRightComponent } from './order-summary-right/order-summary-right.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { VorOrderPopupComponent } from './vor-order-popup/vor-order-popup.component';
import { KbCheckoutPageMetaResolver } from './kb-checkout-page-meta.resolver';
import { onlineOderingGuard } from 'src/app/services/Guards/onlineOrdering/online-odering.guard';

@NgModule({
  declarations: [
    KbCheckoutparentComponent,
    KbcheckoutstepperComponent,
    OrderSummaryComponent,
    OrderSummaryRightComponent,
    AddressSelectPopupComponent,
    kbDateFormatPipe,
    VorOrderPopupComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    KbPipesModule,
    I18nModule,
    UrlModule,
    MediaModule,
    RouterModule,
    MatExpansionModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KbCheckoutFlexComponent: {
          component: KbCheckoutparentComponent,
          guards: [SecureGuard, AuthGuard,onlineOderingGuard],
        },
        OrderConfirmationItemsComponent: {
          component: OrderSummaryComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: KbCheckoutPageMetaResolver,
      multi: true,
    },
  ],
})
export class KbCheckoutModule {}
